import type { Signal } from "@suse-o11y/signal";
import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

import type { TimeRange } from "../../../../../../app/state/view/timeline/TimeRange";

export interface MonitorStatusContextValue {
	timeRange: Signal<TimeRange>;
}

const MonitorStatusContext = createContext<null | MonitorStatusContextValue>(null);

export const MonitorStatusContextProvider = MonitorStatusContext.Provider;

export const useMonitorStatusContext = (): MonitorStatusContextValue =>
	useRequiredContext(MonitorStatusContext, {
		providerName: "MonitorStatusProvider",
	});
